import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import {http_no_auth} from "@utils"
import {toast} from "react-toastify"

export const getStatisticCount = createAsyncThunk('registration/getReestrForHome', async () => {
    const response = await http_no_auth.get('/registration/v1/thing/stats')
    return response.data
})

export const getStatisticByRegions = createAsyncThunk('registration/getStatisticByRegions', async () => {
    const response = await http_no_auth.get('/registration/v1/thing/stats-by-regions')
    return response.data
})

export const statisticSysSlice = createSlice({
    name: 'statistic_for_home',
    initialState: {
        statistic_count: [],

        currentPage: 0,
        totalItem: 0,
        totalPages: 0,
        isLoading: false
    },
    reducers: {},
    extraReducers: {
        [getStatisticCount.fulfilled]: (state, actions) => {
            state.statistic_count = actions.payload?.data
            state.isLoading = false
        },
        [getStatisticCount.pending]: (state) => {
            state.isLoading = true
        },
        [getStatisticCount.rejected]: (state) => {
            toast.error("Error")
            state.isLoading = false
        },

        [getStatisticByRegions.fulfilled]: (state, actions) => {
            state.statistic_region = actions.payload?.data
            state.isLoadingRegion = false
        },
        [getStatisticByRegions.pending]: (state) => {
            state.isLoadingRegion = true
        },
        [getStatisticByRegions.rejected]: (state) => {
            toast.error("Error")
            state.isLoadingRegion = false
        }

    }
})

export const {} = statisticSysSlice.actions
export default statisticSysSlice.reducer